import React, {Fragment, PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {Card, CardBody, CardImg, CardText, CardTitle} from 'reactstrap';
import {toastr} from 'react-redux-toastr';
import Monitor from 'react-feather/dist/icons/monitor.js';
import Smartphone from 'react-feather/dist/icons/smartphone.js';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import FreelanceExamples from '../../components/FreelanceExamples/FreelanceExamples.jsx';
import Header from '../../components/Header/Header.jsx';
import LinkAs from '../../components/LinkAs/LinkAs.jsx';
import IllustratedDiv from '../../components/IllustratedDiv/IllustratedDiv.jsx';
import References from '../../components/References/References.jsx';
import RegisterInvitationModal from '../../components/Modals/RegisterInvitationModal/RegisterInvitationModal.jsx';
import ResetPasswordModal from '../../components/Modals/ResetPassword/ResetPasswordModal.jsx';

import connectModal from '../../../shared/components/Modals/connect.js';
import {generate} from '../../routes.js';
import queryWatcherConnect from '../../components/QueryWatcher/QueryWatcherConnect.js';

import explanatation1 from './images/explanations/1.jpg?size=600';
import explanatation2 from './images/explanations/2.jpg?size=600';
import explanatation3 from './images/explanations/3.jpg?size=600';
import financeImg from '../../media/images/universes/finance.jpg?size=500';
import header from './images/header.jpg?size=600';
import hrImg from '../../media/images/universes/hr.jpg?size=500';
import purchaseImg from '../../media/images/universes/purchase.jpg?size=500';
import supportImg from './images/support.jpg?size=500';

import './Homepage.scss';

const universes = [
  {
    key: 'engineering',
    imgAlt: 'Ingénierie technique',
    imgSrc: supportImg.src,
    text: 'Accédez aux différents profils d\'ingénieurs, qu\'ils soient généralistes ou spécialisés (méthodes, productions, maintenance, supply).',
    title: 'Ingénierie technique'
  },
  {
    key: 'purchase',
    imgAlt: 'Achats, Supply, Contract management',
    imgSrc: purchaseImg.src,
    text: 'Tous profils autour du monde des achats et supply ; responsable achats, acheteur industriel, projet, ou ' +
      'indirect. Contracts manager, SRM, juristes achats, supply chain manager.',
    title: 'Achats, Supply, Contract management'
  },
  {
    key: 'finance',
    imgAlt: 'Corporate Finance',
    imgSrc: financeImg.src,
    text: 'Des profils en contrôle de gestion, trésorerie, comptabilité ou consolidation. Tous types de profils de ' +
      'la Direction Administrative et Financière (DAF).',
    title: 'Corporate Finance'
  },
  {
    key: 'hr',
    imgAlt: 'Ressources humaines',
    imgSrc: hrImg.src,
    text: 'Tous les profils disponibles : de la gestion et de l\'administration de la paie et du personnel au ' +
      'responsable et directeur des Ressources Humaines (DRH).',
    title: 'Ressources humaines'
  }
]

class Homepage extends PureComponent {
  constructor(props) {
    super(props);

    if (props.queryString.action === 'resetPassword') {
      props.openResetPasswordModal({
        user: props.queryString.user,
        token: props.queryString.token
      });
    } else if (props.queryString.action === 'register_invit') {
      props.openRegisterInvitationModal({
        token: props.queryString.register,
        user: props.queryString.user,
      });
    } else if (props.queryString.action === 'confirmDeletion') {
      toastr.success('Votre compte a bien été supprimé.');
    }
  }

  render() {
    const headerBrief = <p>Twineeds permet à des professionnels de toutes les fonctions de l’entreprise (<strong>prod, ingénierie, achat, supply, finance, RH… hors DSI</strong>) de collaborer avec des entreprises en recherche d’accompagnement.</p>;

    const offerSearchLink = generate({name: 'offers'});

    const headerCtas = <Fragment>
      <LinkAs
        className="btn btn-primary"
        do={offerSearchLink}
        freelance={offerSearchLink}
        notConnected={generate({name: 'register-freelance'})}
      >
        Trouver une mission
      </LinkAs>
      <Link className="btn btn-outline-secondary" to={generate({name: 'drop-need'})}>Trouver un expert</Link>
    </Fragment>;

    return (
      <DefaultLayout className="homepage" showSidebarMenu={false}>
        <Header
          brief={headerBrief}
          ctas={headerCtas}
          imageAlt={''}
          imageSrc={header.src}
          title="Des missions pour spécialistes, experts et managers de transition"
        />

        <div className="bg-light">
          <section id="universes" className="container py-5">
            <h2 className="mb-4">Les missions proposées :</h2>
            <div className="row">
              {universes.map(universe => (
                <LinkAs
                  className="col-xs-12 col-md-6 col-lg-3"
                  do={generate({name: 'landing-company-' + universe.key})}
                  freelance={generate({name: 'landing-freelance-' + universe.key})}
                  key={universe.key}
                  notConnected={generate({name: 'landing-freelance-' + universe.key})}
                >
                  <Card className="bg-transparent h-100 mb-4 mb-md-0">
                    <CardImg alt={universe.imgAlt} src={universe.imgSrc}/>
                    <CardBody className="px-0">
                      <CardTitle tag="h3">{universe.title}</CardTitle>
                      <CardText>{universe.text}</CardText>
                    </CardBody>
                  </Card>
                </LinkAs>
              ))}
            </div>
          </section>
        </div>

        <section className="container py-5">
          <IllustratedDiv imgSrc={explanatation1.src} imgAlt="Professionnels : place au choix !">
            <h2 className="mb-3">Professionnels : place au choix&nbsp;!</h2>
            <p>Choisissez la manière dont vous souhaitez travailler et le lieu de vos missions.</p>
            <p>
              Vous proposez votre tarif pour chaque mission en fonction de vos <strong>contraintes personnelles</strong>
              .
            </p>
            <p>
              Twineeds vous recontacte et vous envoie un <strong>SMS pour les missions à pourvoir</strong>. Vous pouvez
              aussi proposer vos services en ligne&nbsp;!
            </p>
            <LinkAs
              className="btn btn-primary"
              do={offerSearchLink}
              freelance={offerSearchLink}
              notConnected={generate({name: 'register-freelance'})}
            >
              Nos missions
            </LinkAs>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={explanatation2.src} imgAlt="Entreprises : faites le choix de Twineeds !">
            <h2 className="mb-3">Entreprises : faites le choix de Twineeds&nbsp;!</h2>
            <p>
              Chaque contexte est différent : nous pouvons vous proposer des profils adaptés à vos besoins, quelque
              soit la mission adressée.
            </p>
            <p>
              Chaque profil a été <strong>rencontré et qualifié</strong> par Twineeds afin de valider s'assurer ses
              compétences "hard skills" et "soft skills".
            </p>
            <Link className="btn btn-primary" to={generate({name: 'landing-company'})}>En savoir plus</Link>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={explanatation3.src} imgAlt="Être rémunéré contre informations !">
            <h2 className="mb-3">Être rémunéré contre informations&nbsp;!</h2>
            <p>
              Apportez-nous des informations de marché <strong>en l'échange d'une rémunération</strong>&nbsp;!
            </p>
            <p>
              Le principe est simple : si vous avez entendu parler d'une mission à pourvoir, donnez nous toutes les
              informations dont vous disposez.
            </p>
            <p>
              Si nous remportons la mission grâce à vos informations, nous vous rémunérons. <Link
                to={generate({name: 'bring-business-cgu'})}>Voir les détails dans les CGU.</Link>
            </p>
            <Link className="btn btn-primary" to={generate({name: 'bring-business'})}>Apporter une affaire</Link>
          </IllustratedDiv>
        </section>

        <div className="bg-light">
          <FreelanceExamples/>
        </div>

        <section id="benefits" className="container text-center py-5">
          <div className="row text-center">
            <div className="col-md-6 p-3 pl-md-5">
              <Monitor/>
              <h3>Travaillez avec les meilleurs consultants</h3>
              <p>
                Proposez vos missions à notre communauté. Définissons votre besoin et nos managers se chargeront de
                vous proposer les profils les plus adaptés.
              </p>
              <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer une mission</Link>
            </div>
            <div className="col-md-6 p-3 pr-md-5">
              <Smartphone/>
              <h3>Recevez des missions de votre métier</h3>
              <p>
                Twineeds vous recontacte en fonction de vos compétences et de vos contraintes exprimées. Vous prenez
                un positionnement adapté pour chaque mission.
              </p>
              <LinkAs
                className="btn btn-primary"
                do={offerSearchLink}
                freelance={offerSearchLink}
                notConnected={generate({name: 'register-freelance'})}
              >
                Recevez des missions
              </LinkAs>
            </div>
          </div>
        </section>

        <div className="bg-light">
          <References className="container text-center py-5"/>
        </div>
      </DefaultLayout>
    );
  }
}

export default queryWatcherConnect(
  connectModal({ResetPasswordModal, RegisterInvitationModal}, Homepage)
);
